<template>
  <div class="sign">
    <van-tabs
      type="card"
      color="#ffffff"
      background="#aaaaaa"
      title-inactive-color="#000000"
      title-active-color="#000000"
      sticky
      @click="tabsClick"
    >
      <van-tab title="SKU"></van-tab>
      <van-tab title="货柜"></van-tab>
    </van-tabs>

    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="search.skuCode"
          placeholder="请扫码SKU"
          right-icon="scan"
          clearable
          clear-trigger="always"
          :formatter="relationNumberFmt"
          @click-right-icon="scanSku"
          @keyup.13="getList()"
          @input="getList"
          @keyup="inputNum"
          ref="scanInp"
        />

        <van-field
          size="small"
          v-model="search.containerNo"
          placeholder="输入货柜号"
          clearable
          clear-trigger="always"
          :formatter="relationNumberFmt"
          @keyup.13="getList()"
          @input="getList"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="headerCheckboxGroup">
      <van-checkbox-group
        direction="horizontal"
        v-model="isBarCodeArr"
        style="justify-content: space-around"
      >
        <van-checkbox name="isBarCode" shape="square"
          >已有条码文件</van-checkbox
        >
        <van-checkbox
          name="isPrintBarCode"
          shape="square"
          v-if="tabType === 'sku'"
          >未打印条码</van-checkbox
        >
        <van-checkbox name="isPrintBarCodeForContainer" shape="square" v-else
          >未完全打印条码</van-checkbox
        >
      </van-checkbox-group>
    </div>

    <van-tabs
      line-width="50%"
      line-height="2px"
      color="#29c727"
      @click="tabsFinishClick"
      v-model="finishedTab"
    >
      <van-tab :title="`未完成(${baleTotal.unfinishedQty || 0})`"></van-tab>
      <van-tab :title="`打包完成(${baleTotal.completeQty || 0})`"></van-tab>
    </van-tabs>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length || list2.length">
          <ul class="bale-sku" v-if="tabType === 'sku'">
            <li v-for="(item, index) in list" :key="index">
              <van-swipe-cell>
                <div class="swipe-div">
                  <div>
                    <template v-if="isShowBaleControl">
                      <van-checkbox
                        v-model="item.checkedForCode"
                        shape="square"
                        style="justify-content: center"
                        :disabled="item.stockingTaskFileId <= 0"
                      ></van-checkbox>
                    </template>
                    <template v-else>
                      <van-checkbox
                        v-model="item.checked"
                        shape="square"
                        style="justify-content: center"
                      ></van-checkbox>
                    </template>
                  </div>
                  <div @click="toBaleSku(0, item)">
                    <div class="sign-list">
                      <p>SKU：{{ item.skuCode }}</p>
                      <p>货柜号：{{ item.containerNo }}</p>
                      <p>
                        进度：{{ item.actualQty || 0 }}/{{ item.quantity || 0 }}
                      </p>
                    </div>
                    <div class="sign-list">
                      <p>发货编码：{{ item.sourceNo }}</p>
                      <p>已打印条码：{{ item.isPrintBarCodeText }}</p>
                      <p>原SKU：{{ item.originalSKU }}</p>
                    </div>
                  </div>
                </div>
                <template #right>
                  <van-button
                    square
                    type="danger"
                    style="height: 100%"
                    :style="{
                      'background-color':
                        item.stockingTaskFileId > 0 ? '#35495e' : '#ccc',
                      'border-color':
                        item.stockingTaskFileId > 0 ? '#35495e' : '#ccc',
                    }"
                    text="打印"
                    @click="item.stockingTaskFileId > 0 ? toPrint(item, 0) : ''"
                  />
                </template>
              </van-swipe-cell>
            </li>
          </ul>

          <ul class="bale-container" v-else>
            <li style="height: 40px; line-height: 40px">
              <template v-if="isShowBaleControl">
                <div style="flex: 0.2"></div>
              </template>
              <div class="bale-container-right">
                <div>货柜号</div>
                <div>进度</div>
              </div>
            </li>
            <li v-for="(item, index) in list2" :key="index">
              <van-swipe-cell>
                <div class="swipe-div">
                  <template v-if="isShowBaleControl">
                    <div style="flex: 0.2">
                      <van-checkbox
                        v-model="item.checkedForCode"
                        shape="square"
                        style="justify-content: center"
                        :disabled="item.stockingTaskFileId <= 0"
                      ></van-checkbox>
                    </div>
                  </template>
                  <div @click="toBaleSku(1, item)" class="bale-container-right">
                    <div>{{ item.containerNo }}</div>
                    <div>
                      {{ item.actualQty || 0 }}/{{ item.quantity || 0 }}
                    </div>
                  </div>
                </div>
                <template #right>
                  <van-button
                    square
                    type="danger"
                    style="height: 100%; top: -4px"
                    :style="{
                      'background-color':
                        item.stockingTaskFileId > 0 ? '#35495e' : '#ccc',
                      'border-color':
                        item.stockingTaskFileId > 0 ? '#35495e' : '#ccc',
                    }"
                    text="打印"
                    @click="item.stockingTaskFileId > 0 ? toPrint(item, 0) : ''"
                  />
                </template>
              </van-swipe-cell>
            </li>
          </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>

      <div class="submit-box" v-if="tabType === 'sku' || isShowBaleControl">
        <div v-if="isShowBaleControl">
          <van-row type="flex" justify="center" align="center">
            <van-col span="8" class="noSend-list-left">
              <van-checkbox
                v-if="tabType === 'sku'"
                v-model="allCheckedCodeForSKU"
                :disabled="!list.length"
                shape="square"
                >全选</van-checkbox
              >
              <van-checkbox
                v-else
                v-model="allCheckedCodeForCon"
                :disabled="!list2.length"
                shape="square"
                >全选</van-checkbox
              >
            </van-col>
            <van-col
              span="16"
              class="noSend-list-right"
              @click="toPrint(null, 1)"
              >打印条码</van-col
            >
          </van-row>
        </div>
        <div v-else>
          <button class="submit-btn" @click="toBaleSku(2)">确定</button>
        </div>
      </div>
    </div>

    <van-action-sheet
      v-model="showActionSheetForPrint"
      :actions="actionsForPrint"
      closeable
      :lazy-render="false"
      cancel-text="取消"
      description="请先选择打印机"
      @select="actionSheetSelectForPrint"
    />

    <van-dialog
      v-model="show"
      title="请选择文件类型"
      :show-cancel-button="true"
      confirmButtonText="打印"
      cancelButtonText="取消"
      :before-close="confirm"
    >
      <div style="height: 50px; text-align: center; line-height: 40px">
        <el-radio v-model="barCodeRadio" :label="1">常规</el-radio>
        <el-radio v-model="barCodeRadio" :label="4">欧英代</el-radio>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Col,
  Row,
  SwipeCell,
  Button,
  ActionSheet,
  Dialog,
  RadioGroup,
  Radio,
} from "vant";
import {
  getBaleForSku,
  getBaleForContainer,
  getIsMixingBox,
  UpdateStockingPlanIsPrintBarCode,
} from "@/api/mobile/bale_api.js";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
import { mapState, mapMutations } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";
import axios from "axios";

export default {
  data() {
    return {
      search: {
        skuCode: "",
        containerNo: "",
        warehouseId: "",
        transportType: "空运",
        statusType: "未完成",
      },
      list: [],
      list2: [],
      startSearch: false,
      tabType: "sku",
      baleTotal: {},
      finishedTab: 0,
      allCheckedCodeForSKU: false,
      allCheckedCodeForCon: false,
      isShowBaleControl: false,
      isBarCodeArr: ["isBarCode"],
      savePrintIdArr: [],
      showActionSheetForPrint: false,
      actionsForPrint: [],
      isSetPrinter: false,
      printSuccess: false,
      savePrintArr: [],
      show: false,
      barCodeRadio: 1,
      printType: 0,
      printList: [],
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Col.name]: Col,
    [Row.name]: Row,
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },

  mixins: [mixins],

  created() {
    this.init();
    this.changeShowBaleControl(false);
  },

  mounted() {
    this.forPC();
  },

  activated() {},

  computed: {
    ...mapState({
      warehouse: (state) => state.common.warehouse,
      showBaleControl: (state) => state.common.showBaleControl,
    }),
  },

  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
      changeShowBaleControl: "changeShowBaleControl",
    }),

    init() {
      this.saveMobileTitle(
        `打包(${this.$route.query.transportType})`
      );
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      this.$set(this.search, "warehouseId", _warehouse.warehouseId);

      this.search.transportType =this.$route.query.transportType;

      this.toGetPrinterByUser();
      this.getList();
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "skuCode", a.resultStr);
          that.getList();
        },
      });
    },

    getList() {
      this.startSearch = true;
      this.allCheckedCodeForSKU = false;
      this.allCheckedCodeForCon = false;
      this.tabType === "sku" ? this.getForSku() : this.getForContainer();
    },

    getForSku() {
      this.list = [];
      this.baleTotal = {};

      const obj = Object.assign({}, this.search, {
        isBarCode: this.isBarCodeArr.includes("isBarCode") ? 1 : 0,
        isPrintBarCode: this.isBarCodeArr.includes("isPrintBarCode") ? 1 : 0,
      });

      getBaleForSku(obj).then((res) => {
        this.startSearch = false;
        if (res.status === 200 && res.success) {
          const { readyforTask, taskMobileQty } = res.response;

          if (!readyforTask.length) Toast("暂无匹配数据");

          this.list = readyforTask;
          this.baleTotal = taskMobileQty;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    getForContainer() {
      this.list = [];
      this.baleTotal = {};

      const obj = Object.assign({}, this.search, {
        isBarCode: this.isBarCodeArr.includes("isBarCode") ? 1 : 0,
        isPrintBarCode: this.isBarCodeArr.includes("isPrintBarCodeForContainer")
          ? 1
          : 0,
      });

      getBaleForContainer(obj).then((res) => {
        this.startSearch = false;
        if (res.status === 200 && res.success) {
          const { readyforTask, taskMobileQty } = res.response;

          if (!readyforTask.length) Toast("暂无匹配数据");

          this.list2 = readyforTask;
          this.baleTotal = taskMobileQty;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    relationNumberFmt(v) {
      return v.trim();
    },

    tabsClick(n, t) {
      this.tabType = n === 0 ? "sku" : "container";
      this.getList();
      this.forPC();
    },

    tabsFinishClick(n, t) {
      this.$nextTick(function () {
        this.search.statusType = n === 0 ? "未完成" : "打包完成";

        this.getList();
      });
    },

    toGetIsMixingBox(type, item) {
      const data = {
        shippingPlanDetailIDS:
          type === 0 ? item.shippingPlanDetailID : item[0].shippingPlanDetailID,
        stockingTaskID:
          type === 0 ? item.stockingTaskID : item[0].stockingTaskID,
      };
      getIsMixingBox(data).then((res) => {
        if (res.status === 200 && res.success) {
          if (type === 0) {
            this.$router.push({
              path:
                res.response == 1
                  ? "/mobile/baleSingleSku"
                  : "/mobile/baleMoreSku",
              query: {
                shippingPlanDetailID: item.shippingPlanDetailID,
                stockingTaskID: item.stockingTaskID,
              },
            });
          } else {
            this.$router.push({
              path:
                res.response == 1
                  ? "/mobile/baleSingleSku"
                  : "/mobile/baleMoreSku",
              query: {
                shippingPlanDetailID: item[0].shippingPlanDetailID,
                stockingTaskID: item[0].stockingTaskID,
              },
            });
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toBaleSku(type, item) {
      if (type === 0) {
        // 单sku
        this.toGetIsMixingBox(type, item);
      } else if (type === 2) {
        const arr = this.list.filter((item1) => {
          return item1.checked;
        });
        const len = arr.length;
        if (!len) return Toast("请先选择一条数据！");

        let s = [],
          sto = [];
        let n = [];
        arr.forEach((item2) => {
          s.push(item2.shippingPlanDetailID);
          sto.push(item2.stockingTaskID);
          n.push(item2.containerNo);
        });

        let flag = false;
        n.forEach((item3, i) => {
          if (n[0] != item3) {
            flag = true;
          }
        });

        if (flag && arr.length > 1) return Toast("请选择相同货柜号的数据");

        arr.length > 1
          ? this.$router.push({
              path: "/mobile/baleMoreSku",
              query: {
                shippingPlanDetailID: s.toString(),
                stockingTaskID: sto.toString(),
              },
            })
          : this.toGetIsMixingBox(type, arr);
      } else {
        this.$router.push({
          path: "/mobile/baleMoreSku",
          query: { containerNo: item.containerNo },
        });
      }
    },

    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();

          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
          } else {
            Toast.fail("打印失败");
          }
        });
    },

    // 弹出打印选择
    toPrint(item, type) {
      if (!this.isSetPrinter) {
        Toast("请选择打印机");
        this.toGetPrinterByUser();
        return;
      }

      if (this.tabType === "sku" && !this.list.length) {
        Toast("暂无数据");
        return;
      }
      if (this.tabType != "sku" && !this.list2.length) {
        Toast("暂无数据");
        return;
      }

      this.printSuccess = false;
      this.show = true;
	  this.printType = type; 
	  this.printList = item;
     
    },

    //打印条码
    confirm(action, done) {
	  let type=this.printType;
	  let item=this.printList;
	  let radio=this.barCodeRadio;
	  console.log(this.printType,item.fileUrls);
      if (action === "confirm") {
        let arr = [];
        if (type === 0 && item.fileUrls.length>0) {
          let taskFile= item.fileUrls.filter((m) => {
            return m.stockingTaskFileType ===radio;
          });
          if(taskFile===null||taskFile.length===0){
			   Toast("佰易未推送"+(radio===1?"常规":"欧英代")+"文件");
               return done(false);
		  }
          taskFile.forEach((item1, i) => {
            this.jsonpPrint(item1.urlPath);
          });
          arr.push(item);
        } else {
          let flag = false,
             flag2 = false;
          if (this.tabType === "sku") {
            this.list.forEach((item1, i1) => {
              if (item1.checkedForCode) {
                flag = true;
                if (item1.stockingTaskFileId > 0) {
                 
                   let taskFile1= item1.fileUrls.filter((m) => {
                     return m.stockingTaskFileType ===radio;
                    });
                if(taskFile1.length>0&&taskFile1!=null){
				 flag2 = true;
                 taskFile1.forEach((item2, i2) => {
                    this.jsonpPrint(item2.urlPath);
                  });
                  if (item1.fileUrls.length) {
                    arr.push(item1);
                  }
				 }
                }
              }
            });
          } else {
            this.list2.forEach((item1, i1) => {
              if (item1.checkedForCode) {
                flag = true;
                if (item1.stockingTaskFileId > 0) {
				let taskFile2= item1.fileUrls.filter((m) => {
                     return m.stockingTaskFileType ===radio;
                    });
				 if(taskFile2.length>0&&taskFile2!=null){
                  flag2 = true;
                  taskFile2.forEach((item2, i2) => {
                    this.jsonpPrint(item2.urlPath);
                  });
                  if (item1.fileUrls.length) {
                    arr.push(item1);
                   }
				  }
                }
              }
            });
          }
          if (!flag){Toast("请先勾选需要打印的数据"); return done(false)} 
          if (!flag2) {Toast("所选数据暂无可打印条码"); return done(false)} 
		
        }
        this.savePrintArr = arr;
		 return done();
      } else {
        return done();
      }
    },

    printBarCode(arr) {
      let data = [],
        that = this;
      arr.forEach((item, i) => {
        data.push({
          stockingTaskID: item.stockingTaskID,
          shippingPlanDetailIDS: item.shippingPlanDetailIDList,
        });
      });

      UpdateStockingPlanIsPrintBarCode(data).then((res) => {
        if (res.status === 200 && res.success) {
          Toast.success(res.msg || "打印成功");
          setTimeout(() => {
            that.getList();
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 查询用户是否设置打印机
    toGetPrinterByUser() {
      const data = {
        moduleType: 1, // 打包 1 ，备柜 2
        wareId: this.search.warehouseId,
      };
      this.isSetPrinter = false;
      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
        }
      });
    },

    // 新增打印机
    toAddUserPrinter(id) {
      const data = {
        moduleType: 1, // 打包 1 ，备柜 2
        printerInfoID: id,
      };
      AddUserPrinter(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200) {
          this.isSetPrinter = true;
          Toast.success(msg || "添加打印机成功");
          this.getList();
        } else {
          Toast(msg);
        }
      });
    },

    actionSheetSelectForPrint(act, i) {
      this.toAddUserPrinter(act.id);
      this.showActionSheetForPrint = false;
    },
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {});
    },
    showBaleControl: {
      handler(n, o) {
        this.isShowBaleControl = n;
      },
      immediate: true,
    },
    allCheckedCodeForSKU: function (o, n) {
      if (o) {
        this.list.forEach((item, i) => {
          if (item.stockingTaskFileId > 0) {
            this.$set(this.list[i], "checkedForCode", true);
          }
        });
      } else {
        this.list.forEach((item, i) => {
          if (item.stockingTaskFileId > 0) {
            this.$set(this.list[i], "checkedForCode", false);
          }
        });
      }
    },
    allCheckedCodeForCon: function (o, n) {
      if (o) {
        this.list2.forEach((item, i) => {
          if (item.stockingTaskFileId > 0) {
            this.$set(this.list2[i], "checkedForCode", true);
          }
        });
      } else {
        this.list2.forEach((item, i) => {
          if (item.stockingTaskFileId > 0) {
            this.$set(this.list2[i], "checkedForCode", false);
          }
        });
      }
    },
    printSuccess: function (o, n) {
      if (o) {
        this.printBarCode(this.savePrintArr);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.sign-item {
  margin-bottom: 80px;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 90px;
}

.sign-toSearch {
  width: 100%;
  height: 65%;
  min-height: 80px;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}

::v-deep .van-checkbox__icon {
  background-color: #fff;
}

.sign-item .bale-sku li {
  display: flex;
  align-items: center;
  padding: 0;
  & > div:first-child {
    flex: 0.15;
  }
  & > div:last-child {
    flex: 1;
    p:last-child {
      flex: 0.8;
      padding-left: 10px;
      box-sizing: border-box;
    }
  }
}

.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  align-items: center;
  padding: 0;
  & > div {
    flex: 1;
    text-align: center;
  }

  .bale-container-right {
    display: flex;
    & > div {
      flex: 1;
    }
  }
}

.sign-item .bale-sku .swipe-div {
  display: flex;
  align-items: center;
  & > div {
    flex: 1;
    &:first-child {
      flex: 0.2;
    }
    &:last-child {
      display: flex;
      & > div {
        flex: 1;
      }
    }
    & > .sign-list {
      flex-direction: column;
      & > p {
        padding: 0 !important;
      }
    }
  }
}

.sign-item .bale-container .swipe-div {
  display: flex;
  align-items: center;
  & > div {
    flex: 1;
    &:last-child {
      display: flex;
      & > div {
        flex: 1;
      }
    }
    & > .sign-list {
      flex-direction: column;
      & > p {
        padding: 0 !important;
      }
    }
  }
}

.headerCheckboxGroup {
  padding-bottom: 10px;
}

.noSend-list-left {
  border-top: 1px solid #908d8d;
  border-bottom: 1px solid #908d8d;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding: 8px 0 0 32px;
  background-color: #fff;
}
.noSend-list-right {
  border-top: 1px solid #908d8d;
  border-bottom: 1px solid #908d8d;
  height: 40px;
  line-height: 40px;
  background-color: #35495e;
  color: #fff;
}
</style>